export default {
  data() {
    return {
      otaTokenPlatformConst: [
        {label: 'Airbnb', value: 'airbnb'},
        {label: 'Smily', value: 'smily'},
      ],
    };
  },
  methods: {
    displayForOtaTokenPlatformConst(value) {
      const result = this.otaTokenPlatformConst.find((el) => el.value === value);
      return result ? result.label : value;
    },
  },
};
